module.exports = __webpack_public_path__ + "static/nulshock_ul-webfont-7d2cc2d957e44cae68fbc05bb426fb7d.woff2";